import { createContext } from 'react';
import initialGoogleAddressState from './initialGoogleAddressState';

const GoogleAddressContext = createContext(initialGoogleAddressState);

export default GoogleAddressContext;
